export default /* glsl */ `varying vec2 vUV;

void setRawUV(vec4 xyzw) {
  vUV = xyzw.xy;
}
`;
